import {InjectionToken} from '@angular/core';

export const REQUEST = new InjectionToken('REQUEST');
export const RESPONSE = new InjectionToken<Response>('RESPONSE');
